"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFlattenOptions = void 0;
const getFlattenOptions = (options) => {
    const optionArray = [];
    options.forEach((option) => {
        if (option.options) {
            option.options.forEach((o) => {
                optionArray.push(Object.assign(Object.assign({}, o), { label: o.label || o.value, value: o.value, group: option.label }));
            });
        }
        else {
            optionArray.push(Object.assign(Object.assign({}, option), { label: option.label || option.value, value: option.value }));
        }
    });
    return optionArray;
};
exports.getFlattenOptions = getFlattenOptions;
//# sourceMappingURL=index.js.map